module.exports = __webpack_public_path__ + "static/media/how-to-3.31878be0.svg";